import { render, staticRenderFns } from "./Keyword.vue?vue&type=template&id=81bd9f0e&scoped=true&"
import script from "./Keyword.vue?vue&type=script&lang=js&"
export * from "./Keyword.vue?vue&type=script&lang=js&"
import style0 from "./Keyword.vue?vue&type=style&index=0&id=81bd9f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bd9f0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
